module.exports = "https://callcenter.pagoefectivolatam.com/pagoEfectivo.51bc1fceb87aba1db30fc47e77fd7e37.png";